import { MenuItem, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { useState } from "react";

function HoverHelper(props) {
  const [image, setImage] = React.useState(props.normalImage);
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = props.hoverImage;
  }, [props.hoverImage]);

  const over = (e) => {
    setHovered(!hovered);
  };

  const out = (e) => {
    setHovered(!hovered);
  };

  const openPdfInNewTab = () => {
    if (decoded_jwtToken.companyType === "NONE") {
      window.open("https://myspprivacy.s3.us-east-1.amazonaws.com/J9W3C7L5D.pdf", "_blank");
    }
    if (decoded_jwtToken.companyType === "PARTNER") {
      window.open("https://myspprivacy.s3.us-east-1.amazonaws.com/B4N8T6R2Y.pdf", "_blank");
    }
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      window.open("https://myspprivacy.s3.us-east-1.amazonaws.com/X7K9M2Q8P1.pdf", "_blank");
    }
  };

  return (
    <>
      <MenuItem
        onMouseOver={over}
        onMouseOut={out}
        component={Link}
        onClick={openPdfInNewTab}
        className="profileMenu"
        to={props.link}
        sx={{
          "&:hover": {
            backgroundColor: "rgba(144, 144, 144, 0.1)",
            "& .MuiTypography-root": {
              color: "#F2824C",
            },
          },
        }}
      >
        <img
          src={hovered ? props.hoverImage : props.normalImage}
          alt={props.alt}
          style={{ paddingRight: "10px" }}
        />
        <Typography
          sx={{
            fontFamily: "font_regular",
            color: props.darkMode ? "rgba(221, 221, 221, 1)" : "#434547",
          }}
        >
          {props.item}
        </Typography>
      </MenuItem>
    </>
  );
}

export default HoverHelper;
